import { Link } from "react-router-dom";
import { Lock } from "lucide-react";
import { NAV_LINKS } from "./navConstants";

export function SiteFooter({ vereine, isMemberLoggedIn }) {
  return (
    <footer className="border-t border-white/10 py-12 px-4 md:px-8">
      <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <h3 className="text-lg font-bold uppercase tracking-tight mb-3" style={{ fontFamily: 'Oswald', color: '#fbbf24' }}>Ninersbillard</h3>
          <p className="text-sm text-muted-foreground">Deine Sportsbar im Herzen von Wels</p>
          <p className="text-sm text-muted-foreground mt-1">Billard &bull; Darts &bull; Events &bull; Kultur</p>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-3">Kontakt</h4>
          <p className="text-sm text-muted-foreground">Stelzhamerstraße 9</p>
          <p className="text-sm text-muted-foreground">4600 Wels</p>
          <a href="tel:+437242216406" className="block text-sm text-muted-foreground hover:text-foreground mt-3 py-1" data-testid="footer-phone">
            Tel: +43 (0)7242 216406
          </a>
          <a href="mailto:office@ninersbillard.com" className="block text-sm text-muted-foreground hover:text-foreground py-1" data-testid="footer-email">
            office@ninersbillard.com
          </a>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mt-5 mb-3">Onlinepräsenz</h4>
          <div className="flex items-center gap-4">
            <a href="https://www.facebook.com/ninersbillard/" target="_blank" rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-facebook" aria-label="Facebook">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="https://www.instagram.com/ninersbillard/" target="_blank" rel="noopener noreferrer"
              className="text-muted-foreground hover:text-foreground transition-colors" data-testid="footer-instagram" aria-label="Instagram">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
            </a>
          </div>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-3">Vereine</h4>
          {vereine.map(club => (
            <Link key={club.id} to={`/club/${club.id}`}
              className="block text-sm text-muted-foreground hover:text-foreground py-1">{club.name}</Link>
          ))}
          <Link to="/ligaplatzierung"
            className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground py-1 mt-2 pt-2 border-t border-white/5">
            Ligaplatzierung
            {!isMemberLoggedIn && <Lock className="w-3 h-3 text-muted-foreground" />}
          </Link>
          <Link to="/downloads"
            className="flex items-center gap-1 text-sm text-muted-foreground hover:text-foreground py-1">
            Downloads
          </Link>
          <Link to="/club/sportuebertragungen"
            className="block text-sm text-muted-foreground hover:text-foreground py-1">Sportübertragungen</Link>
        </div>
        <div>
          <h4 className="text-sm font-semibold uppercase tracking-widest text-muted-foreground mb-3">Navigation</h4>
          {NAV_LINKS.map(link => (
            <Link key={link.path} to={link.path}
              className="block text-sm text-muted-foreground hover:text-foreground py-1">{link.label}</Link>
          ))}
        </div>
      </div>
      <div className="max-w-6xl mx-auto mt-8 pt-4 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-2 text-xs text-muted-foreground pb-10">
        <span>&copy; {new Date().getFullYear()} Simply N Gastro und Handels GmbH. Alle Rechte vorbehalten.</span>
        <div className="flex items-center gap-4">
          <span data-testid="footer-version" className="opacity-50">v1.2.0</span>
          <Link to="/impressum" className="hover:text-foreground" data-testid="footer-impressum">Impressum</Link>
          <Link to="/datenschutz" className="hover:text-foreground" data-testid="footer-datenschutz">Datenschutz</Link>
          <Link to="/mitglied-login" className="hover:text-foreground" data-testid="footer-member-login">Mitglieder-Bereich</Link>
        </div>
      </div>
    </footer>
  );
}
